export class AssignmentPatch {
    estimatedCost: number;
    jobCost: number;
    noOfUnits: number;
    costingType: string;
}
